import React, { Component } from 'react';
import Slider from 'react-slick';

import './style.sass';

function SampleNextArrow(props) {
    const { onClick } = props;

    return (
        <button className="zkhArrowNext__container">
            <div
                className="zkhArrowPrev-inner__container zkhArrowPrev-inner__container--next"
                onClick={onClick}
            >
                <span className="zkhArrowPrev-inner__span" />
            </div>
        </button>
    );
}

function SamplePrevArrow(props) {
    const { onClick } = props;

    return (
        <div className="zkhArrowPrev__container">
            <div className="zkhArrowPrev-inner__container" onClick={onClick}>
                <span className="zkhArrowPrev-inner__span" />
            </div>
        </div>
    );
}

export default class SimpleSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            slideIndex: 0,
        };
    }

    render() {
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow className={'slider-zkhfoundation__arrow-next'} />,
            prevArrow: <SamplePrevArrow className={'slider-zkhfoundation__arrow-prev'} />,
            beforeChange: (current, next) => this.setState({ slideIndex: next }),
        };

        return (
            <div>
                <Slider {...settings}>
                    {this.props.info.map(({ img }, index) => (
                        <div key={index} className="slider-zkhfoundation__item">
                            <div className="slider-zkhfoundation__img">
                                <img src={img} alt="" loading="lazy" />
                            </div>
                        </div>
                    ))}
                </Slider>
                <div className="slider-zkhfoundation__numbers">
                    <div className="slider-zkhfoundation__counter">
                        {this.state.slideIndex + 1}/{this.props.info.length}
                    </div>
                </div>
            </div>
        );
    }
}
